import cAppeared from '../components/c-appeared';
import { projectStats } from '../../../blocks/project-stats/scripts/project-stats';

export default function () {
  cAppeared();
  projectStats();
}
